import SituacionLaboralUpdate from './SituacionLaboralUpdate'
export {SituacionLaboralUpdate}
export default SituacionLaboralUpdate
